import { render, staticRenderFns } from "./FoodStuffSearchList.vue?vue&type=template&id=338c95da&scoped=true"
import script from "./FoodStuffSearchList.vue?vue&type=script&lang=js"
export * from "./FoodStuffSearchList.vue?vue&type=script&lang=js"
import style0 from "./FoodStuffSearchList.vue?vue&type=style&index=0&id=338c95da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c95da",
  null
  
)

export default component.exports